import { createFileRoute } from "@tanstack/react-router";
import GiftSdkHostPage from "@/site/pages/gift-sdk-host";

// Public, un-authwalled, chrome-less host for the partner (Jifiti) gift-card SDK,
// loaded ONLY inside the mobile app's webview (the picker's `sdk` phase). It is
// stateless — no session, no auth — and gets everything the SDK needs from the
// `window.__GIFT_INIT__` object the webview injects before load (PRD 10 §9).
// __root.tsx renders it outside SiteLayout (chrome-free) and lets it through the
// logged-out guard (public).
export const Route = createFileRoute("/gift/sdk-host")({
  component: GiftSdkHostPage,
});
